<template>
  <div>
    <v-row dense class="mb-2" align="center">
      <v-col cols="12" sm="auto">
        <v-btn-toggle v-model="vista" mandatory dense tile color="blue darken-2">
          <v-btn value="pendientes" small>Pendientes</v-btn>
          <v-btn value="hoy" small>Hoy</v-btn>
          <v-btn value="historial" small>Historial</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="6" sm="3" lg="2" v-if="vista === 'hoy' || vista === 'historial'">
        <v-text-field
          v-model="fecha"
          label="Fecha operativa"
          type="date"
          filled
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="3" lg="2" v-if="vista === 'historial'">
        <v-text-field
          v-model="fechaHasta"
          label="Hasta"
          type="date"
          filled
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn color="primary" small tile :loading="cargando" @click="cargarChecklist">
          <v-icon left small>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-chip small class="mr-1" color="blue lighten-4">Meta {{ resumen.meta }}</v-chip>
        <v-chip small class="mr-1" color="teal lighten-4">Operativas {{ resumen.operativas }}</v-chip>
        <v-chip small color="grey lighten-3">Total {{ resumen.total }}</v-chip>
      </v-col>
    </v-row>

    <v-alert dense text type="info" class="mb-3">
      La palomita registra <strong>declaración del estratega</strong> (usuario + fecha).
      No significa que el cambio esté verificado en Meta. V4/V5 no escriben en Meta desde aquí.
      Las propuestas del Consultor deben verse en <strong>Pendientes</strong> (o Hoy).
      Si aparece el botón <strong>Al checklist</strong>, incorpórala antes de declarar.
    </v-alert>

    <v-alert v-if="errorApi" dense text type="error" class="mb-3">
      No se pudo cargar el CHECKLIST ({{ marca }}): {{ errorApi }}
      <div class="caption mt-1">Revisa en Red la llamada a <code>api/ci/meta/checklist</code> (no confundir con Susana <code>/susana-v3/admin/handoffs</code>).</div>
    </v-alert>

    <v-alert v-if="!cargando && !errorApi && !items.length" dense text type="warning" class="mb-3">
      No hay ítems para {{ marca }} en esta vista.
      <div class="caption mt-1" v-if="diagnostico">
        API OK · usuario {{ diagnostico.id_usuario }} · permiso marcas: {{ (diagnostico.marcas_permiso || []).join(', ') || '—' }}
        · crudas {{ diagnostico.meta_antes_filtro_marca }} → tras filtro {{ diagnostico.meta_despues_filtro }}.
      </div>
      <div class="caption" v-else>
        El API respondió vacío sin diagnóstico (¿api-rh caído o sin pull?).
        Confirma que <code>localhost:3004</code> esté arriba y pulsa <strong>Actualizar</strong>.
      </div>
      <div class="caption grey--text" v-if="ultimaUrl">Última ruta: {{ ultimaUrl }} · resumen Meta {{ resumen.meta }} / Op {{ resumen.operativas }}</div>
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="cargando"
      item-key="clave"
      dense
      elevation-0
      :items-per-page="25"
      class="elevation-0"
    >
      <template v-slot:item.ambito="{ item }">
        <v-chip x-small :color="item.ambito === 'META' ? 'blue lighten-4' : 'teal lighten-4'">
          {{ item.ambito }}
        </v-chip>
      </template>
      <template v-slot:item.prioridad="{ item }">
        <span>{{ item.prioridad }}</span>
      </template>
      <template v-slot:item.objeto="{ item }">
        <div class="caption">
          <div v-if="item.ad_id">ad {{ item.ad_id }}</div>
          <div v-if="item.adset_id">adset {{ item.adset_id }}</div>
          <div v-if="item.campaign_id">camp {{ item.campaign_id }}</div>
          <div v-if="!item.ad_id && !item.adset_id && !item.campaign_id" class="grey--text">—</div>
        </div>
      </template>
      <template v-slot:item.presupuesto="{ item }">
        <span v-if="item.presupuesto_actual != null">
          ${{ Number(item.presupuesto_actual).toFixed(0) }}
          <span v-if="item.presupuesto_propuesto != null">
            → ${{ Number(item.presupuesto_propuesto).toFixed(0) }}
          </span>
        </span>
        <span v-else class="grey--text">—</span>
      </template>
      <template v-slot:item.estado="{ item }">
        <v-chip x-small :color="colorEstado(item)">{{ item.estado }}</v-chip>
        <div v-if="item.etiqueta_ejecucion" class="caption orange--text text--darken-3">
          {{ item.etiqueta_ejecucion }}
        </div>
        <div v-if="item.requiere_aprobacion_presupuesto" class="caption red--text">
          Requiere aprobación de presupuesto
        </div>
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-btn
          v-if="item.ambito === 'META' && !item.en_checklist && item.estado === 'PROPUESTA' && !item.bloqueada"
          x-small
          tile
          color="blue darken-2"
          dark
          class="mr-1 mb-1"
          :loading="busyId === item.clave"
          @click="incorporar(item)"
        >
          Al checklist
        </v-btn>
        <v-btn
          v-if="item.ambito === 'META' && item.requiere_aprobacion_presupuesto && item.en_checklist"
          x-small
          tile
          color="amber darken-2"
          dark
          class="mr-1 mb-1"
          :loading="busyId === item.clave"
          @click="aprobar(item)"
        >
          Aprobar $
        </v-btn>
        <v-btn
          v-if="puedeDeclarar(item)"
          x-small
          tile
          color="green darken-1"
          dark
          class="mr-1 mb-1"
          :loading="busyId === item.clave"
          @click="declarar(item)"
        >
          <v-icon left x-small>mdi-check</v-icon>
          Hecha
        </v-btn>
        <v-btn
          x-small
          tile
          text
          class="mb-1"
          @click="verDetalle(item)"
        >
          Detalle
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogo" max-width="720">
      <v-card v-if="detalle">
        <v-toolbar flat dense color="blue darken-2" dark>
          <v-toolbar-title class="subtitle-1">{{ detalle.tipo }} · {{ detalle.ambito }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogo = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <div><strong>Marca / sucursal:</strong> {{ detalle.marca }} · {{ detalle.sucursal || '—' }}</div>
          <div><strong>Estratega:</strong> {{ detalle.estratega_nombre || detalle.estratega_id || '—' }}</div>
          <div><strong>Prioridad:</strong> {{ detalle.prioridad }}</div>
          <div class="mt-2"><strong>Instrucción:</strong> {{ detalle.instruccion }}</div>
          <div class="mt-2" v-if="detalle.diagnostico"><strong>Justificación:</strong> {{ detalle.diagnostico }}</div>
          <div class="mt-2 caption" v-if="detalle.ad_id || detalle.adset_id || detalle.campaign_id || detalle.creative_id">
            <div v-if="detalle.ad_id"><strong>Anuncio origen:</strong> {{ detalle.ad_id }}</div>
            <div v-if="detalle.creative_id"><strong>Creative origen:</strong> {{ detalle.creative_id }}</div>
            <div v-if="detalle.adset_id"><strong>Conjunto destino:</strong> {{ detalle.adset_id }}</div>
            <div v-if="detalle.campaign_id"><strong>Campaña:</strong> {{ detalle.campaign_id }}</div>
            <div v-if="detalle.producto"><strong>Producto:</strong> {{ detalle.producto }}</div>
          </div>
          <div class="mt-3" v-if="briefCreativo">
            <strong>Brief creativo (ejecutable)</strong>
            <div class="caption mt-1" v-if="briefCreativo.cta"><strong>CTA:</strong> {{ briefCreativo.cta }}</div>
            <div class="caption" v-if="briefCreativo.recurso_visual">
              <strong>Recurso visual:</strong>
              {{ briefCreativo.recurso_visual.object_type || '—' }}
              <span v-if="briefCreativo.recurso_visual.video_id"> · video {{ briefCreativo.recurso_visual.video_id }}</span>
              <div v-if="briefCreativo.recurso_visual.instruccion">{{ briefCreativo.recurso_visual.instruccion }}</div>
            </div>
            <div class="caption mt-2" v-if="briefCreativo.copy_original_inspeccionado">
              <strong>Copy original inspeccionado:</strong>
              <pre class="pa-2 grey lighten-4" style="white-space:pre-wrap;max-height:140px;overflow:auto">{{ briefCreativo.copy_original_inspeccionado }}</pre>
            </div>
            <div class="caption mt-2" v-if="briefCreativo.copy_adaptado_propuesto">
              <strong>Copy adaptado propuesto:</strong>
              <pre class="pa-2 blue lighten-5" style="white-space:pre-wrap;max-height:160px;overflow:auto">{{ briefCreativo.copy_adaptado_propuesto }}</pre>
            </div>
            <div class="caption mt-1" v-if="(briefCreativo.conservar || []).length">
              <strong>Conservar:</strong> {{ (briefCreativo.conservar || []).join('; ') }}
            </div>
            <div class="caption" v-if="(briefCreativo.cambiar || []).length">
              <strong>Cambiar:</strong> {{ (briefCreativo.cambiar || []).join('; ') }}
            </div>
            <div class="caption orange--text text--darken-3 mt-1" v-if="(briefCreativo.datos_pendientes || []).length">
              <strong>Pendiente confirmación:</strong> {{ (briefCreativo.datos_pendientes || []).join(' · ') }}
            </div>
          </div>
          <div class="mt-2" v-if="detalle.presupuesto_actual != null">
            <strong>Presupuesto:</strong>
            ${{ Number(detalle.presupuesto_actual).toFixed(2) }}
            → ${{ detalle.presupuesto_propuesto != null ? Number(detalle.presupuesto_propuesto).toFixed(2) : '—' }}
          </div>
          <div class="mt-2">
            <strong>Aprobación:</strong> {{ detalle.estado_aprobacion || '—' }}
            <span v-if="detalle.requiere_aprobacion_presupuesto" class="red--text"> (pendiente)</span>
          </div>
          <div><strong>Estado ejecución:</strong> {{ detalle.estado }}</div>
          <div v-if="detalle.etiqueta_ejecucion" class="orange--text text--darken-3">{{ detalle.etiqueta_ejecucion }}</div>
          <div><strong>Generada:</strong> {{ detalle.creado_at || detalle.fecha_operativa }}</div>
          <div><strong>Evaluación prevista:</strong> {{ detalle.fecha_evaluacion || '—' }}</div>
          <div v-if="detalle.declarada_at">
            <strong>Declarada:</strong> {{ detalle.declarada_at }} por usuario {{ detalle.declarada_por }}
          </div>
          <div class="mt-3" v-if="eventos.length">
            <strong>Historial de transiciones</strong>
            <v-simple-table dense>
              <thead>
                <tr><th>Cuándo</th><th>Evento</th><th>De→A</th><th>Actor</th><th>Nota</th></tr>
              </thead>
              <tbody>
                <tr v-for="e in eventos" :key="e.id">
                  <td>{{ e.creado_at }}</td>
                  <td>{{ e.evento }}</td>
                  <td>{{ e.de_estado || '—' }} → {{ e.a_estado || '—' }}</td>
                  <td>{{ e.actor_id || '—' }}</td>
                  <td>{{ e.nota || '—' }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <pre v-if="detalle.evidencia" class="caption mt-3 pa-2 grey lighten-4" style="white-space:pre-wrap;max-height:200px;overflow:auto">{{ evidenciaTexto }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
  </div>
</template>

<script>
  import Alerta from '@/components/alertas/Alerta.vue'
  import validarErrores from '@/mixins/validarErrores'
  import { mapGetters } from 'vuex'

  export default {
    components: { Alerta },
    mixins: [validarErrores],
    props: {
      marca: { type: String, required: true },
    },
    data () {
      const hoy = new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Monterrey' })
      return {
        vista: 'pendientes',
        fecha: hoy,
        fechaHasta: hoy,
        items: [],
        resumen: { meta: 0, operativas: 0, total: 0 },
        cargando: false,
        busyId: null,
        dialogo: false,
        detalle: null,
        eventos: [],
        errorApi: '',
        ultimaUrl: '',
        diagnostico: null,
        headers: [
          { text: 'Ámbito', value: 'ambito', width: 90 },
          { text: 'Sucursal', value: 'sucursal' },
          { text: 'Estratega', value: 'estratega_nombre' },
          { text: 'Tipo', value: 'tipo' },
          { text: 'Pri', value: 'prioridad', width: 48 },
          { text: 'Instrucción', value: 'instruccion', width: 280 },
          { text: 'Objeto', value: 'objeto', width: 120 },
          { text: 'Presupuesto', value: 'presupuesto', width: 110 },
          { text: 'Estado', value: 'estado', width: 140 },
          { text: 'Eval.', value: 'fecha_evaluacion', width: 100 },
          { text: '', value: 'acciones', sortable: false, width: 200 },
        ],
      }
    },
    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP']),
      briefCreativo () {
        if (!this.detalle || !this.detalle.config_propuesta) return null
        try {
          const c = typeof this.detalle.config_propuesta === 'string'
            ? JSON.parse(this.detalle.config_propuesta)
            : this.detalle.config_propuesta
          if (!c || typeof c !== 'object') return null
          if (!c.copy_original_inspeccionado && !c.copy_adaptado_propuesto && !c.cta) return null
          return c
        } catch (e) {
          return null
        }
      },
      evidenciaTexto () {
        if (!this.detalle || this.detalle.evidencia == null) return ''
        try {
          const e = typeof this.detalle.evidencia === 'string'
            ? JSON.parse(this.detalle.evidencia)
            : this.detalle.evidencia
          return JSON.stringify(e, null, 2)
        } catch (err) {
          return String(this.detalle.evidencia)
        }
      },
    },
    watch: {
      marca () { this.cargarChecklist() },
      vista () { this.cargarChecklist() },
    },
    mounted () {
      this.cargarChecklist()
    },
    methods: {
      colorEstado (item) {
        if (item.bloqueada || item.estado === 'BLOQUEADA') return 'red lighten-4'
        if (item.estado === 'DECLARADA_REALIZADA' || item.estado === 'HECHA') return 'green lighten-4'
        if (item.estado === 'APROBADA') return 'light-green lighten-4'
        if (item.requiere_aprobacion_presupuesto) return 'amber lighten-3'
        return 'grey lighten-3'
      },
      puedeDeclarar (item) {
        if (item.ambito === 'OPERATIVA') return ['PROPUESTA', 'ASIGNADA'].includes(item.estado)
        if (item.bloqueada) return false
        if (['REDUCE_BUDGET', 'REALLOCATE_BUDGET'].includes(item.tipo)) {
          return ['APROBADA', 'EN_EJECUCION'].includes(item.estado)
        }
        return ['APROBADA', 'EN_EJECUCION', 'PENDIENTE'].includes(item.estado) && !!item.en_checklist
      },
      // No llamar "cargar": el mixin validarErrores define data.cargar (boolean) y tapa el método.
      cargarChecklist () {
        this.cargando = true
        this.errorApi = ''
        this.diagnostico = null
        const params = { marca: this.marca, vista: this.vista, _: Date.now() }
        if (this.vista === 'hoy') params.fecha_operativa = this.fecha
        if (this.vista === 'historial') {
          params.fecha_desde = this.fecha
          params.fecha_hasta = this.fechaHasta || this.fecha
        }
        this.ultimaUrl = 'api/ci/meta/checklist'
        return this.$http.get('api/ci/meta/checklist', { params })
          .then((r) => {
            const data = r.data
            if (!data || typeof data !== 'object' || Array.isArray(data)) {
              this.errorApi = 'Respuesta inválida del API (¿HTML 404 u otra ruta?).'
              this.items = []
              this.resumen = { meta: 0, operativas: 0, total: 0 }
              this.validarError(this.errorApi)
              return
            }
            if (data.ok === false) {
              this.errorApi = data.message || 'El API rechazó el checklist'
              this.items = []
              this.validarError(this.errorApi)
              return
            }
            this.diagnostico = data.diagnostico || null
            this.items = (data.items || []).map((it) => ({
              ...it,
              clave: `${it.ambito}-${it.id}`,
            }))
            this.resumen = data.resumen || { meta: 0, operativas: 0, total: 0 }
          })
          .catch((e) => {
            const status = e.response && e.response.status
            const body = e.response && e.response.data
            let msg = (body && body.message) || e.message || 'Error de red'
            const bodyStr = typeof body === 'string' ? body : ''
            if (/ECONNREFUSED|Could not proxy/i.test(bodyStr) || /ECONNREFUSED/i.test(String(e.message || ''))) {
              msg = 'api-rh no responde en :3004 (proxy ECONNREFUSED). Arranca el API y pulsa Actualizar.'
            } else if (/cannot get/i.test(bodyStr)) {
              msg = `Ruta no encontrada en el API (${status || 404}). ¿Falta deploy de api-rh?`
            }
            if (status === 403) {
              msg = (body && body.message) || 'Sin permiso ci_meta (alcance ver). Pide alta en ci_meta_permisos.'
            }
            this.errorApi = msg
            this.diagnostico = (body && body.diagnostico) || null
            this.validarError(msg)
            this.items = []
            this.resumen = { meta: 0, operativas: 0, total: 0 }
          })
          .finally(() => { this.cargando = false })
      },
      incorporar (item) {
        this.busyId = item.clave
        this.$http.post(`api/ci/meta/acciones/${item.id}/incorporar-checklist`)
          .then(() => {
            this.validarSuccess('Incorporada al CHECKLIST')
            this.cargarChecklist()
          })
          .catch((e) => this.validarError((e.response && e.response.data && e.response.data.message) || e.message))
          .finally(() => { this.busyId = null })
      },
      aprobar (item) {
        this.busyId = item.clave
        this.$http.post(`api/ci/meta/acciones/${item.id}/aprobar`)
          .then(() => {
            this.validarSuccess('Presupuesto aprobado')
            this.cargarChecklist()
          })
          .catch((e) => this.validarError((e.response && e.response.data && e.response.data.message) || e.message))
          .finally(() => { this.busyId = null })
      },
      declarar (item) {
        this.busyId = item.clave
        const url = item.ambito === 'OPERATIVA'
          ? `api/ci/meta/tareas/${item.id}/declarar`
          : `api/ci/meta/acciones/${item.id}/declarar`
        this.$http.post(url, { observaciones: 'Declarada desde CHECKLIST CI' })
          .then((r) => {
            const aviso = (r.data && r.data.aviso) || 'Declarada. No es verificación Meta.'
            this.validarSuccess(aviso)
            this.cargarChecklist()
          })
          .catch((e) => this.validarError((e.response && e.response.data && e.response.data.message) || e.message))
          .finally(() => { this.busyId = null })
      },
      verDetalle (item) {
        this.detalle = item
        this.eventos = []
        this.dialogo = true
        const url = item.ambito === 'OPERATIVA'
          ? `api/ci/meta/tareas/${item.id}/eventos`
          : `api/ci/meta/acciones/${item.id}`
        this.$http.get(url)
          .then((r) => {
            const data = r.data || {}
            if (item.ambito === 'META') {
              this.detalle = { ...item, ...(data.accion || {}) }
              this.eventos = data.eventos || []
            } else {
              this.eventos = data.eventos || []
            }
          })
          .catch(() => { this.eventos = [] })
      },
    },
  }
</script>
